<template>
    <div class="form-group">
        <template v-if="!isCodeSent || phoneToVerify !== phone || phoneNumberCodeToVerify !== phoneNumberCode">
            <div v-if="isSendingCodeError" class="invalid-feedback-erreur">
                {{titles.errorSendingVerificationCode}}
            </div>
            <b-button
                    :disabled="!isPhoneValid || isSendingCode"
                    @click="sendVerificationCode"
                    pill
                    size="sm"
                    variant="success"
                    class="my-0 mx-auto px-3 d-block waves-effect waves-light"
                    type="button"
            >
                <b-spinner small v-if="isSendingCode"></b-spinner>
                Vérifier
            </b-button>
        </template>
        <div v-else class="mb-3">
            <small id="emailHelp" class="form-text text-muted">Un code de vérification est envoyé à votre numéro</small>
            <label for="code">Code de vérification</label>
            <PincodeInput
                    id="code"
                    :value="code"
                    placeholder="-"
                    :length="6"
                    class="w-100 justify-content-center"
                    :class="{'invalid-code': error}"
                    @input="handleInput"
            />
            <div v-if="error" class="invalid-feedback-erreur">
                {{titles.invalidVerificationCode}}
            </div>
        </div>
    </div>
</template>

<script>
    import PincodeInput from 'vue-pincode-input';
    import {required} from 'vuelidate/lib/validators';
    import {sendVerificationCode} from "../../shared/services/phone.service";
    import {titles} from '../../../utils/general/titles';

    export default {
        name: "phoneVerification",
        components: {PincodeInput},
        data() {
            return {
                titles,
                isCodeSent: false,
                isSendingCode: false,
                phoneToVerify: null,
                phoneNumberCodeToVerify: null,
                isSendingCodeError: false
            }
        },
        props: {
            phone: {required},
            phoneNumberCode: {required},
            isPhoneValid: {required},
            code: {required},
            error: {
                type: Boolean,
                default: false
            }
        },
        model: {
            prop: 'code',
            event: 'input'
        },
        methods: {
            sendVerificationCode() {
                this.isSendingCode = true;
                this.isSendingCodeError = false;
                sendVerificationCode(this.phone, this.phoneNumberCode).then(
                    () => {
                        this.isCodeSent = true;
                        this.phoneToVerify = this.phone;
                        this.phoneNumberCodeToVerify = this.phoneNumberCode;
                        this.isSendingCode = false;
                    }
                ).catch(
                    () => {
                        this.isSendingCodeError = true;
                        this.isCodeSent = false;
                        this.isSendingCode = false;
                    }
                )
            },
            handleInput(value) {
                this.$emit("input", value)
            }
        }
    }
</script>

<style>
    .invalid-code input.vue-pincode-input {
        border: 1px solid #ef4d56 !important;
        box-shadow: 0 0 3px rgb(241 99 107) !important;
    }
</style>
